<style scoped>
</style>

<style scoped>
@import "https://fonts.googleapis.com/icon?family=Material+Icons";
@import "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined";

::placeholder {
  color: #fff !important;
  opacity: 1; /* Firefox */
}
.logo-placeholder {
  box-shadow: none !important;
}
.sshi-icon {
  padding: 0.5rem;
  max-width: 120px;
  max-height: 120px;
  width: auto;
  height: auto;
}
.sshi-logo {
  padding: 0.5rem;
  max-width: 80px;
  max-height: 80px;
  width: auto;
  height: auto;
}

.sshi-logo2 {
  margin: 0.25rem;
  border-radius: 50% !important;
  /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px; */
}

.sshi-logo3 {
  margin-left: 4rem;
  margin-right: 4rem;
  border-radius: 50% !important;
  /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px; */
}

.sshi-banner {
  margin-bottom: 0px;
  padding-top: 5em;
  background-image: url("/img/sshi/bg-scenery.webp");
  text-align: center;
  min-height: 25em;
}
.sshi-text {
  color: #fff !important;
}
.yellow-line {
  margin-left: 30%;
  margin-right: 30%;
  background-color: #ffdf12;
  height: 5px;
  border-radius: 20px;
}
.overlap-header {
  margin-top: -10em;
}
.slide-root {
  margin-top: -7em;
  padding-left: 7em;
  padding-right: 7em;
}
.slide-bag {
  /* margin-left: 1em;
  margin-right: 1em; */
  /* max-width: 200px; */
  border-radius: 1em;
  padding: 0em;
  background-color: white;
  /* max-height: 250px; */
  color: rgb(0, 60, 128);
}
.slide-arrow {
  background-color: #ffff;
  border-radius: 100%;
  padding-top: 1.2em;
  padding-bottom: 2.2em;
  color: rgb(0, 147, 221);
}
</style>
<template>
  <b-container
    fluid
    style="
      width: 100%;
      padding-bottom: 5%;
      font-family: 'Inter', 'sans-serif' !important;
      padding-left: 0px;
      padding-right: 0px;
    "
  >
    <b-jumbotron class="sshi-banner text-center">
      <h1 class="sshi-text" style="margin-bottom: 0px !important">
        Daftar Berita
      </h1>
    </b-jumbotron>
    <b-row class="overlap-header ml-5 mr-5">
      <b-col class="ml-5 mr-5">
        <div
          style="
            background-color: white;
            padding: 3em 5em 3em 5em;
            border-radius: 1em;
            text-align: justify;
          "
        >
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th scope="col">Judul</th>
                <th scope="col">Pembuat Konten</th>
                <th scope="col">Waktu Dibuat</th>
                <th scope="col" class="text-center">Aksi</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in contents" :key="index">
                <td>{{ item.title }}</td>
                <td>{{ item.creator }}</td>
                <td>{{ item.createdAt }}</td>
                <td class="text-center">
                  <button
                    class="btn btn-warning btn-sm mr-2"
                    @click="editContent(index)"
                  >
                    Edit
                  </button>
                  <button
                    class="btn btn-danger btn-sm"
                    @click="deleteContent(index)"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {
  name: "sshi-news-manajemen",
  data() {
    return {
      contents: [
        {
          title: "Judul Konten 1",
          creator: "Pembuat 1",
          createdAt: "2025-01-05 10:30",
        },
        {
          title: "Judul Konten 2",
          creator: "Pembuat 2",
          createdAt: "2025-01-06 11:00",
        },
      ],
      ceklogin: false,
    };
  },
  created() {},
  mounted() {
    this.cekLogin();
  },
  setup() {},
  methods: {
    editContent(index) {
      // Logika untuk edit konten
      alert(`Edit konten dengan index ${index}`);
    },
    deleteContent(index) {
      // Logika untuk delete konten
      if (confirm("Apakah Anda yakin ingin menghapus konten ini?")) {
        this.contents.splice(index, 1);
        alert("Konten berhasil dihapus");
      }
    },
    cekLogin() {
      let status = JSON.parse(localStorage.getItem("vuex"));
      if (status.auth.status == 0 || status == "") {
        this.ceklogin = true;
      }
      console.log(status);
    },
    keLogin() {
      window.location.href = "/login";
    },
  },
};
</script>




<style scoped>
/* Tambahkan styling khusus di sini jika diperlukan */
</style>